import { defineComponent, onMounted, ref, watch } from 'vue';
import { EnvCheckService } from '@/services/exam/envCheck.service';
import { useService } from '@kaokei/use-vue-service';
export default defineComponent({
  name: 'MicroVideo',
  props: {
    stream: Object
  },
  setup: function (props) {
    var envCheckService = useService(EnvCheckService);
    var microVideoRef = ref();
    var microError = ref(true);
    var start = function () {
      if (microVideoRef.value) {
        microVideoRef.value.controls = false;
        microVideoRef.value.srcObject = props.stream;
        microVideoRef.value.onloadedmetadata = function () {
          microError.value = false;
          microVideoRef.value.play();
        };
      }
    };
    onMounted(function () {
      watch(function () {
        return props.stream;
      }, function () {
        if (props.stream) {
          start();
        }
      }, {
        immediate: true
      });
    });
    return {
      microVideoRef: microVideoRef,
      microError: microError,
      envCheckService: envCheckService
    };
  }
});